import { SourcingInternalAnalysisSelectionTable } from 'modules/sourcing-internal/tables/SourcingInternalAnalysisSelectionTable';

export const SourcingInternalChooseAnalysisStep: React.FC = () => {
  return <SourcingInternalAnalysisSelectionTable />;
};
